import { createContext, ReactNode, useContext } from "react";
import { useLocalStorage } from "../hooks";

type ShippingLocationType = {
  id: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  formatted_address?: string;
  address_street_1?: string;
  address_street: string;
  latitude: string;
  longitude: string;
  state_code: string;
  city_name: string;
  zip_code: string;
};

type ShippingProviderProps = {
  children?: ReactNode;
};

type ShippingContextProps = {
  shippingLocation?: ShippingLocationType | undefined;
  setShippingLocation: (location: any) => void;
  isLocationSelected: boolean;
};

const ShippingContext = createContext({} as ShippingContextProps);

export function useShipping() {
  return useContext(ShippingContext);
}

export function ShippingProvider({ children }: ShippingProviderProps) {
  // const [shippingLocation, setShippingLocation] = useState<ShippingLocationType>()
  const [shippingLocation, setShippingLocation] = useLocalStorage<
    ShippingLocationType | any
  >("shipping", []);
  const isLocationSelected =
    shippingLocation && !!Object.keys(shippingLocation).length ? true : false;
  // const isLocationSelected = (Object.keys(shippingLocation).length) ? true : false;

  return (
    <ShippingContext.Provider
      value={{ shippingLocation, setShippingLocation, isLocationSelected }}
    >
      {children}
    </ShippingContext.Provider>
  );
}
